export class EntitySelectorResultDto {
    entityId: number;
    name: string;
}
